import * as React from 'react';
import { assertNever } from 'owa-assert';
import {
    DetailsRow,
    IDetailsRowProps,
    IObjectWithKey,
} from 'office-ui-fabric-react/lib/DetailsList';
import { NewFolderRow } from './NewFolderRow';

const customRowKeys = Object.freeze({
    newFolder: true,
});

type CustomRowKey = keyof typeof customRowKeys;

export function getCustomRowKeysMap() {
    return customRowKeys;
}

export function getAllCustomRowItems(): IObjectWithKey[] {
    return Object.keys(customRowKeys).map(key => ({ key }));
}

export function FolderSelectorRow(props: IDetailsRowProps) {
    const item: IObjectWithKey = props.item;

    if (customRowKeys[item.key]) {
        return renderCustomRowElement(item.key as CustomRowKey, props);
    }

    return <DetailsRow {...props} />;
}

function renderCustomRowElement(customRowKey: CustomRowKey, props: IDetailsRowProps) {
    switch (customRowKey) {
        case 'newFolder':
            return <NewFolderRow {...props} />;
        default:
            return assertNever(customRowKey);
    }
}
